/* @flow */
import * as React from 'react';

import UserAvatar from 'users/components/UserAvatar';
import type { Props as UserAvatarProps } from 'users/components/UserAvatar';

import getField from '../ComposableTableField';
import type { Field } from '../ComposableTableField';

export function getUserAvatarCellGenerator(input: {
  fieldForAction?: Field,
  userField?: Field,
  onClickAction?: (SyntheticEvent<>, any) => void,
  userAvatarProps?: $Shape<UserAvatarProps>,
}) {
  return (data: Object) => {
    const { fieldForAction, onClickAction, userAvatarProps, userField } = input;

    return (
      <UserAvatar
        {...userAvatarProps}
        user={getField(data, userField)}
        size="medium"
        onClick={e => onClickAction && onClickAction(e, getField(data, fieldForAction))}
      />
    );
  };
}
